import { SttFragment } from '@ftr/contracts/regional-api/stt'
import { generateUuid, Uuid } from '@ftr/contracts/type/shared'
import { RealTimeSttSegmentMap } from '../../../types'
import { TransactionResult } from './operation-result'

export interface EditRemarkTextOperation {
  type: 'editRemarkText'
  remarkId: Uuid
  updatedFragments: SttFragment[]
}

export function editRemarkTextTransaction(
  operation: EditRemarkTextOperation,
  segmentMap: RealTimeSttSegmentMap,
): TransactionResult {
  // Find the remark in the segment map
  const remark = segmentMap.findRemark(operation.remarkId)
  if (!remark) {
    throw new Error(`Remark with ID ${operation.remarkId} not found in segment map`)
  }

  return {
    type: 'transaction',
    transaction: {
      id: generateUuid(),
      edits: [
        {
          type: 'upsertUtterance',
          utteranceId: operation.remarkId,
          fragments: operation.updatedFragments,
          dialect: remark.dialect ?? null,
          speakerId: remark.speakerId,
        },
      ],
    },
    sideEffects: [],
  }
}
